module.exports = __webpack_public_path__ + "img/cs_logo.a6442d06.png";